import Vue from 'vue';

Vue.filter('csv', function(value) {
    return value.join(', ');
});
